import { render, staticRenderFns } from "./DiseasesUpdate.vue?vue&type=template&id=7a629140&scoped=true"
import script from "./DiseasesUpdate.vue?vue&type=script&lang=js"
export * from "./DiseasesUpdate.vue?vue&type=script&lang=js"
import style0 from "./DiseasesUpdate.vue?vue&type=style&index=0&id=7a629140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a629140",
  null
  
)

export default component.exports